import _ from 'lodash'
import quickwordApi from '@/api/quickWords'

const QuickWords = {
	state: {
		quickwordList: [],
		inputQuickWord: '',
		dictList: [],
	},
	mutations: {
		SET_INPUT_QUICK_WORD: (state, payload) => {
			state.inputQuickWord = payload
		},
		SET_QUICK_WORD_LIST: (state, payload) => {
			state.quickwordList = payload
		},
		SET_DICT_LIST: (state, payload) => {
			state.dictList = payload
		},
	},
	actions: {
		// 获取快捷用语
		getQuickWordsList: async ({ dispatch, commit }) => {
			try {
        dispatch('getDictList')
				const { data } = await quickwordApi.getList()
				console.log('%c Line:27 🧀拿到快捷语数据 data', 'color:#e41a6a', data)
				if (data) {
					commit('SET_QUICK_WORD_LIST', data)
				} else {
					commit('SET_QUICK_WORD_LIST', [])
				}
			} catch (error) {
				commit('SET_QUICK_WORD_LIST', [])
			}
		},
		getDictList: async ({ commit }) => {
			try {
				const { data } = await quickwordApi.getDict()
				console.log('%c Line:27 🧀拿到字典数据 data', 'color:#e41a6a', data)
				if (data) {
					commit('SET_DICT_LIST', data)
				} else {
					commit('SET_DICT_LIST', [])
				}
			} catch (error) {
				commit('SET_DICT_LIST', [])
			}
		},
	},
}

export default QuickWords
